import { useEffect, useRef } from "react";

import { INACTIVITY_TIMEOUT_MS } from "@/constants/auth-session.constants";

const ACTIVITY_EVENTS = ["keydown", "click", "scroll", "touchstart", "mousedown"] as const;
const IDLE_CHECK_INTERVAL_MS = 10_000;

export function useIdleTimeout(onIdle: () => void, enabled: boolean) {
  const onIdleRef = useRef(onIdle);
  onIdleRef.current = onIdle;

  const lastActivityRef = useRef(Date.now());

  useEffect(() => {
    if (!enabled) return;

    lastActivityRef.current = Date.now();

    const resetTimer = () => {
      lastActivityRef.current = Date.now();
    };

    ACTIVITY_EVENTS.forEach((event) => {
      window.addEventListener(event, resetTimer, { passive: true });
    });

    const intervalId = window.setInterval(() => {
      if (Date.now() - lastActivityRef.current >= INACTIVITY_TIMEOUT_MS) {
        onIdleRef.current();
      }
    }, IDLE_CHECK_INTERVAL_MS);

    return () => {
      window.clearInterval(intervalId);
      ACTIVITY_EVENTS.forEach((event) => {
        window.removeEventListener(event, resetTimer);
      });
    };
  }, [enabled]);
}

export default useIdleTimeout;
